import keyBy from 'lib/utils/keyBy';

import { ADD_AWAIT_PRODUCTS, ADD_PRODUCTS } from '../actions/products';
import {
  ADD_PRODUCT_DETAILS,
  ADD_SIMILAR_PRODUCTS,
  ADD_STATIC_CONTENT,
  ADD_RECOMMENDATIONS,
  ADD_RECIPES,
  ADD_OPTION,
  ADD_CRITEO_SPONSORED_PRODUCTS,
  CLEAR_OPTIONS,
  UPDATE_PRODUCT_BASIC_INFO,
} from '../actions/productDetails';
import { ADD_FEEDBACK_CORRECTION_TYPES } from '../actions/feedback';

import {
  ADD_TO_FAVOURITES,
  REMOVE_FROM_FAVOURITES,
} from 'apps/favourites/actions/favourites';
import ProductLabel from 'apps/products/models/ProductLabel';

export const INITIAL_STATE = {
  awaitProductsBySku: [],
  productsBySku: {}, // TODO add cache invalidation!!
  productDetailsBySku: {},
  productFeedback: {
    correctionTypes: [],
  },
  sponsoredProducts: [],
};

const reducers = {
  [ADD_AWAIT_PRODUCTS]: (state, action) => ({
    ...state,
    awaitProductsBySku: [
      ...action.skus.filter(sku => state.awaitProductsBySku.indexOf(sku) === -1), //  Remove duplicates
      ...state.awaitProductsBySku,
    ],
  }),
  [ADD_PRODUCTS]: (state, action) => {
    // action = { type, products }
    const receivedProductSkus = action.products.map((product) => product.sku);

    return {
      ...state,
      productsBySku: {
        ...state.productsBySku,
        ...keyBy(action.products, 'sku'),
      },
      awaitProductsBySku: (
        // Remove from array received products
        state.awaitProductsBySku.filter(sku => receivedProductSkus.indexOf(sku) === -1)
      ),
    };
  },
  [ADD_SIMILAR_PRODUCTS]: (state, action) => ({
    ...state,
    productDetailsBySku: {
      ...state.productDetailsBySku,
      [action.sku]: { ...state.productDetailsBySku[action.sku], ...{ similarProducts: action.similarProducts } },
    },
  }),
  [ADD_RECOMMENDATIONS]: (state, action) => ({
    ...state,
    productDetailsBySku: {
      ...state.productDetailsBySku,
      [action.sku]: { ...state.productDetailsBySku[action.sku], ...{ recommendations: action.recommendations } },
    },
  }),
  [ADD_RECIPES]: (state, action) => ({
    ...state,
    productDetailsBySku: {
      ...state.productDetailsBySku,
      [action.sku]: { ...state.productDetailsBySku[action.sku], ...{ recipes: action.recipes } },
    },
  }),
  [CLEAR_OPTIONS]: (state, action) => {
    const options = state.productDetailsBySku[action.sku].options.slice(0, action.index);
    return {
      ...state,
      productDetailsBySku: {
        ...state.productDetailsBySku,
        [action.sku]: { ...state.productDetailsBySku[action.sku], ...{ options } },
      },
    };
  },
  [ADD_OPTION]: (state, action) => {
    let options;
    if (action.index === 0) {
      options = [action.value];
    } else {
      options = state.productDetailsBySku[action.sku].options.slice(0, action.index);
      options[action.index] = action.value;
    }
    return {
      ...state,
      productDetailsBySku: {
        ...state.productDetailsBySku,
        [action.sku]: { ...state.productDetailsBySku[action.sku], ...{ options } },
      },
    };
  },
  [UPDATE_PRODUCT_BASIC_INFO]: (state, action) => {
    const { parentSku, data = {} } = action;
    let { product, backOfPack } = data;

    backOfPack = {
      ...state.productDetailsBySku[parentSku].backOfPack,
      catchweightMinWeight: { ...backOfPack.catchweightMinWeight },
      catchweightMaxWeight: { ...backOfPack.catchweightMaxWeight },
      tags: { ...backOfPack.tags },
      images: [...backOfPack.images],
      bopFields: { ...backOfPack.bopFields },
    };
    if (product.sku === parentSku) {
      product = { ...product };
    } else {
      product = {
        ...state.productDetailsBySku[parentSku].product,
        price: product.price,
        optionName: product.name,
        image: product.image,
        derivativeSku: product.sku,
      };
    }

    return {
      ...state,
      productDetailsBySku: {
        ...state.productDetailsBySku,
        [parentSku]: {
          ...state.productDetailsBySku[parentSku],
          product,
          backOfPack,
        },
      },
    };
  },
  [ADD_PRODUCT_DETAILS]: (state, action) => {
    // action = { type, productDetails }
    const { sku } = action.productDetails.product;
    return {
      ...state,
      // add the basic product data to cache
      productsBySku: {
        ...state.productsBySku,
        [sku]: action.productDetails.product,
      },
      // add the detailed product info to cache
      // for not we keep data only for one product, but in future we could easily change only by reducer modification
      productDetailsBySku: {
        ...state.productDetailsBySku,
        [sku]: action.productDetails,
      },
    };
  },
  [ADD_TO_FAVOURITES]: (state, action) => {
    const product = state.productsBySku[action.sku];
    if (!product) {
      return state;
    }
    product.labels = product.labels || [];
    product.labels.push(ProductLabel.FAVOURITE);
    return {
      ...state,
      productsBySku: {
        ...state.productsBySku,
        [action.sku]: { ...state.productsBySku[action.sku], ...product },
      },
    };
  },
  [REMOVE_FROM_FAVOURITES]: (state, action) => {
    const product = state.productsBySku[action.sku];
    if (!product) {
      return state;
    }
    product.labels = product.labels.filter(item => item !== ProductLabel.FAVOURITE);
    return {
      ...state,
      productsBySku: {
        ...state.productsBySku,
        [action.sku]: { ...state.productsBySku[action.sku], ...product },
      },
    };
  },
  [ADD_STATIC_CONTENT]: (state, action) => ({
    ...state,
    banners: action.staticContent,
  }),
  [ADD_FEEDBACK_CORRECTION_TYPES]: (state, action) => ({
    ...state,
    feedbackCorrectionTypes: action.correctionTypes,
  }),
  [ADD_CRITEO_SPONSORED_PRODUCTS]: (state, action) => ({
    ...state,
    productDetailsBySku: {
      ...state.productDetailsBySku,
      [action.sku]: {
        ...state.productDetailsBySku[action.sku],
        ...{ criteoSponsoredProducts: action.criteoSponsoredProducts },
      },
    },
  }),
};

export default (state = INITIAL_STATE, action) => (
  reducers[action.type]
    ? reducers[action.type](state, action)
    : state
);
